<template>
  <div class="page">
    <section class="main-wrap">
      <div class="main-cont reg-cont clear">
        <div class="main-header">
          <div class="main-h-l"><a href="javascript:void(0);" title="返回首页"><img src="../../assets/images/login/wz_logo_c.png"></a><span>注册吾征AI获得更多智能信息</span></div>
          <a href="javascript:void(0);" @click="returnIndex" class="main-h-r">回首页看看</a>
        </div>
        <div class="main-form reg-form clear">
          <div class="main-f-tit">信息</div>
          <form action="#">
            <ul>
              <li>
                <em>验证码</em>
                <label class="reg-mob-coder">
                  <input type="number" v-model="code" placeholder="短信验证码"></label>
                <div class="reg-mob coder-off">
                  <a class="btn" href="javascript:void(0);" id="sendMobileCode" @click="sendMobileCode">
                    <span id="dyMobileButton">获取验证码</span>
                  </a>
                </div>
              </li>
              <li>
                <em>密码</em>
                <label><input type="password" v-model="userPassword" placeholder="请输入密码"></label>
              </li>
              <li>
                <em>密码确认</em>
                <label><input type="password" v-model="twoPassword" placeholder="请确认密码"></label>
              </li>
            </ul>
            <div class="reg-notice">
              <input type="checkbox"><a href="javascript:void(0);">同意《注册须知》</a>
            </div>
            <div class="main-f-input but">
              <label><input type="button" @click="determine()" value="注册"></label>
            </div>
          </form>
          <div class="main-pass">
            我有帐号，去<a href="javascript:void(0);" @click="login">登录</a>
          </div>
        </div>
        <div class="copy">Copyright © 2017-2021 中润普达 － <a href="javascript:void(0);" target="_blank">京ICP备2021002262号-1</a></div>
      </div>
    </section>
  </div>
</template>

<script>
import '@/assets/css/login.css'
import { request } from '@/network/request'
import { Message } from 'element-ui'

export default {
  data () {
    return {
      code: null,
      userPassword: null,
      twoPassword: null,
      phone: null,
      flag: false,
      time: 60,
    }
  },
  created () {
    this.getQuery();
  },
  methods: {
    // 获取上个页面传递参数
    getQuery () {
      let _this = this;
      _this.phone = _this.$route.query.phone
      $(this).attr('disabled', true).css("pointer-events", "none");
      var timer = setInterval(function () {
        if (_this.time > 0) {
          _this.time--;
          $('#dyMobileButton').html(_this.time + ' s 重新发送');
        } else if (_this.time == 0) {
          $('#dyMobileButton').removeAttr('disabled');
          $('#dyMobileButton').html('获取验证码');
          clearInterval(timer);
          _this.time = 60;
          _this.flag = true;
        }
      }, 1000);
    },
    // 返回首页
    returnIndex () {
      this.$router.push('/');
    },
    // 登录
    login () {
      this.$router.push('/login');
    },
    //发送验证码
    sendMobileCode () {
      let _this = this;
      $(this).attr('disabled', true).css("pointer-events", "none");
      if (_this.flag) {
        var timer = setInterval(function () {
          if (_this.time == 60 && _this.flag) {
            _this.flag = false;
            request({
              url: '/sendSms',
              method: 'get',
              params: {
                'phone': _this.phone
              },
            }).then(res => {
              if (res.data.code == 200) {
                $('#dyMobileButton').html('已发送');
              } else {
                Message(res.data.msg);
                _this.flag = true;
                _this.time = 60;
                clearInterval(timer);
              }
            })
          } else if (_this.time == 0) {
            $('#dyMobileButton').removeAttr('disabled');
            $('#dyMobileButton').html('获取验证码');
            clearInterval(timer);
            _this.time = 60;
            _this.flag = true;
          } else {
            $('#dyMobileButton').html(_this.time + ' s 重新发送');
            _this.time--;
          }
        }, 1000);
      }
    },
    // 确定按钮
    determine () {
      let _this = this;
      if (_this.code == null) {
        Message('请输入验证码');
        return;
      }
      if (_this.userPassword == null) {
        Message('请输入密码');
        return;
      }
      if (_this.twoPassword == null) {
        Message('请输入确认密码');
        return;
      }
      if (_this.userPassword == _this.twoPassword) {
        request({
          url: '/resetPwd',
          method: 'get',
          params: {
            'userPhone': _this.phone,
            'password': _this.userPassword,
            'code': _this.code,
          },
        }).then(res => {
          if (res.data.code == 200) {
            _this.$router.push('/registerSuccess')
          } else{
             Message(res.data.msg);
          }
        })
      } else {
        Message('两次密码输入不一致');
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/login/registerTwo.vue